import type { ExportModalEntity } from "./types";
import type { CountryTabValue } from "./types";

/**
 * Filters entities by selected country tab.
 * "ALL" returns all entities; otherwise returns entities whose country matches.
 * Entities with null country are included only when value is "ALL".
 * Pure function.
 */
export function filterEntitiesByCountry(
  entities: ExportModalEntity[],
  countryValue: CountryTabValue,
): ExportModalEntity[] {
  if (countryValue === "ALL") {
    return [...entities];
  }
  return entities.filter((e) => e.country === countryValue);
}
